import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {NoticeBoard} from "../../../../modules/notice-board/notice-board.types";
import {NoticeBoardService} from '../../../../modules/notice-board/notice-board.service';
import {AppService} from '../../../../app.service';

@Component({
    selector: 'notice-board-dialog-detail',
    templateUrl: './dialog-detail.component.html',
    styleUrls: ['./dialog-detail.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class NoticeBoardDialogDetailComponent implements OnInit {
    downloading = false;
    downloadError = '';

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            notice: NoticeBoard
        },
        private _dialogRef: MatDialogRef<NoticeBoardDialogDetailComponent>,
        private noticeBoardService: NoticeBoardService,
        private appService: AppService
    ) {
    }

    ngOnInit(): void {
    }

    async downloadAttachment(): Promise<void> {
        if (this.downloading || !this.data.notice.attachmentKey) return;
        this.downloading = true;
        this.downloadError = '';
        try {
            const buffer = await this.noticeBoardService.downloadAttachment(this.data.notice.attachmentKey).toPromise();
            const name = this.data.notice.attachmentKey.split('|').pop();
            const extension = name.split('.').pop().toLowerCase();
            const mimeTypes: Record<string, string> = {
                pdf: 'application/pdf', xls: 'application/vnd.ms-excel', xlsx: this.appService.EXCEL_TYPE,
                doc: 'application/msword', docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                ppt: 'application/vnd.ms-powerpoint', pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                csv: 'text/csv', txt: 'text/plain', jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', zip: 'application/zip',
            };
            await this.appService.downloadFile(new Uint8Array(buffer), mimeTypes[extension] || 'application/octet-stream', name);
        } catch (error) {
            this.downloadError = 'Não foi possível baixar o anexo. Tente novamente.';
        } finally {
            this.downloading = false;
        }
    }

    close(): void {
        this._dialogRef.close();
    }
}
